export default __webpack_public_path__ + "static/media/dots.e028f6bd.svg";